module.exports = __webpack_public_path__ + "assets/img/n1.72434a21.jpg";